import { useAuthStore } from '../../store/AuthStore';
import { ROLES } from '../../utils/roleUtils';

export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: {
    canAccessOrg: false,
    canManageSystem: true,
    canCreateOrg: true,
    sidebar: ['dashboard', 'organizations', 'administration', 're-entry'],
  },
  [ROLES.OWNER]: {
    canAccessOrg: true,
    canManageOrg: true,
    canManageUsers: true,
    sidebar: [
      'communications',
      'data-insights',
      'grants',
      'reentry',
      'administration',
    ],
  },
  [ROLES.ADMIN]: {
    canAccessOrg: true,
    canManageUsers: true,
    canViewData: true,
    sidebar: [
      'communications',
      'data-insights',
      'grants',
      'reentry',
      'administration',
    ],
  },
  [ROLES.STAFF]: {
    canAccessOrg: true,
    canViewData: true,
    sidebar: [
      'communications',
      'data-insights',
      'grants',
      'reentry',
    ],
  },
};

export const useRoleAccess = () => {
  const { user } = useAuthStore();

  if (!user || !user.role) {
    return {
      userRole: null,
      permissions: {},
      canAccess: () => false,
      getSidebarItems: () => [],
    };
  }

  const permissions = ROLE_PERMISSIONS[user.role] || {};

  return {
    userRole: user.role,
    permissions,
    canAccess: (permission) => permissions[permission] === true,
    getSidebarItems: () => permissions.sidebar || [],
    isRole: (role) => user.role === role,
  };
};

export const useOrgAccess = () => {
  const { user } = useAuthStore();
  const orgRoles = [ROLES.OWNER, ROLES.ADMIN, ROLES.STAFF];

  return {
    hasOrgAccess: user && orgRoles.includes(user.role),
    isSuperAdmin: user && user.role === ROLES.SUPER_ADMIN,
    userRole: user?.role,
  };
};
